import React from 'react';
import PropTypes from 'prop-types';

class Description extends React.Component {
    render() {
        const { desc, noellipsis, 'data-testid': dataTestId } = this.props;
        let description;

        function createDescriptionFromArray(arr) {
            return arr.filter(Boolean).join(' \u2022 ');
        }
        if (typeof desc === 'string' || typeof desc === 'number') {
            description = desc;
        } else if (typeof desc === 'object') {
            description = createDescriptionFromArray(desc);
        }
        if (noellipsis) {
            return (
                <span dangerouslySetInnerHTML={{ __html: description }} title={description} data-testid={dataTestId || undefined} />
            );
        }
        return (
            <span className="show-ellipsis d-block" dangerouslySetInnerHTML={{ __html: description }} title={description} data-testid={dataTestId || undefined} />
        );
    }
}

Description.propTypes = {
    'data-testid': PropTypes.string,
};

Description.defaultProps = {
    'data-testid': null,
};

export default Description;
